import { Flex } from "../../components/Flex";
import { Slider } from "../../components/Slider";
import { Loader } from "../../components/Loader";
import { CheckStatusEnum } from "../../context/MandateStatusContext";
import { CheckContainer, CheckTitle } from "./CheckStyledComponents";
import { ManualAcceptReject } from "./ManualAcceptReject";
import { CheckFields } from "./CheckFields";
import { ScreeningResultView } from "./ScreeningResultView";
import {
  individualCheckQueryKey,
  useIndividualCheck,
} from "../../data/useIndividualCheck";
import { queryClient } from "../../queryClient";

/**
 * The mandate Screening check: fetches one IndividualCheck and renders it.
 *
 * The body lives in ScreeningResultView, which takes records rather than an id,
 * because the Monitoring record view renders the same body from a different
 * endpoint. Everything specific to a mandate check stays here: the title, the
 * check-level accept and reject, and the check fields. The approval comment
 * banner is rendered inside ScreeningResultView (layout="split"), since it
 * sits within the same tinted decision shell as Information Used / Check
 * Results there.
 */
export const ScreeningCheck = (props: any) => {
  const {
    isOpen,
    onRequestClose,
    id,
    useSlider = true,
    type,
    permissionCodename,
    permissionDeniedMessage,
  } = props;

  const { data: individualCheckData, isLoading: isLoadingIndividualCheck } =
    useIndividualCheck(id);

  const instance = individualCheckData?.data?.instance;
  const status = individualCheckData?.data?.status?.status;

  const title = "Screening";

  const content = (
    <>
      <CheckContainer style={{ marginRight: useSlider ? "48px" : 0 }}>
        <Flex justifyContent="space-between">
          <CheckTitle>{title}</CheckTitle>

          {status === CheckStatusEnum.Review && (
            <ManualAcceptReject
              id={id}
              title={title}
              isMonitoring={false}
              permissionCodename={permissionCodename}
              permissionDeniedMessage={permissionDeniedMessage}
            />
          )}
        </Flex>

        <CheckFields
          individual_checkfield_result={
            individualCheckData?.data?.individual_checkfield_result
          }
        />

        <ScreeningResultView
          records={instance?.records || []}
          status={status}
          type={type}
          layout="split"
          approvalComment={instance?.approval_comment}
          onDecisionUpdated={() =>
            queryClient.invalidateQueries(individualCheckQueryKey(id))
          }
        />
      </CheckContainer>
    </>
  );

  return (
    <>
      {isLoadingIndividualCheck ? (
        <Flex justifyContent="center" alignItems="center" minHeight="60vh">
          <Loader />
        </Flex>
      ) : useSlider ? (
        <Slider
          isOpen={isOpen}
          onRequestClose={() => onRequestClose(false)}
          width="70%"
        >
          {content}
        </Slider>
      ) : (
        content
      )}
    </>
  );
};
